import { CurrencyModel } from './CurrencyModel';

export class CountryModel {

  public id: number = null;
  public name: string = null;
  public code: string = null;
  public isEuroZone: boolean = null;
  public defaultCurrency: CurrencyModel = null;
  public defaultCountryCallingCode: string = null;
  public showInPhonePicker: boolean = null;

  constructor() { }

  static fromJson(json): CountryModel {
    if (!json) {
      return null;
    }
    const model = new CountryModel();
    model.id = json.id;
    model.name = json.name;
    model.code = json.code || json.countryCode;
    model.isEuroZone = json.isEuroZone;
    model.defaultCurrency = json.defaultCurrency ? CurrencyModel.fromJson(json.defaultCurrency) : null;
    model.defaultCountryCallingCode = json.defaultCountryCallingCode == "NULL" ? null : json.defaultCountryCallingCode?.split(' ')[0]
    model.showInPhonePicker = json.showInPhonePick;
    return model;
  }
}
